import React from 'react';
import { Form, Input } from 'antd';
import { PrimaryButton, Modal, H3 } from 'utils';
import styled from '@emotion/styled';

const ModalContent = styled.div`
  width: 500px;
  max-height: 70vh;
  overflow-y: auto;
`;

const FormItem = Form.Item;

const PromotionCategoryModal = ({
  showModal,
  editingCategory,
  loading,
  form,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal showModal={showModal} handelCloseModal={onClose}>
      <ModalContent>
        <H3>{editingCategory ? 'Kategorie bearbeiten' : 'Neue Kategorie'}</H3>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
        >
          <FormItem
            label="Name"
            name="name"
            rules={[
              { required: true, message: 'Bitte geben Sie einen Namen ein' }
            ]}
          >
            <Input placeholder="Kategorie Name" />
          </FormItem>
          <FormItem
            label="Beschreibung"
            name="description"
          >
            <Input.TextArea
              placeholder="Beschreibung (optional)"
              rows={4}
            />
          </FormItem>
          <PrimaryButton
            type="primary"
            htmlType="submit"
            loading={loading}
            minWidth="100px"
          >
            {editingCategory ? 'Aktualisieren' : 'Hinzufügen'}
          </PrimaryButton>
        </Form>
      </ModalContent>
    </Modal>
  );
};

export default PromotionCategoryModal;
